import { useScreen } from '@hb/react'
import { useMemo } from 'react'
import { DefaultModal } from '../../components/Modals'
import { EncounterForm } from './EncounterForm'
import { EncounterSelection } from './types'

export interface EncounterFormModalProps {
  openEncounter: EncounterSelection | null
  patientId: string | null
  assessmentId?: string | null
  onClose: () => void
  onSuccess: (exam: EncounterSelection) => void
}

export const EncounterFormModal = ({
  openEncounter,
  patientId,
  assessmentId,
  onClose,
  onSuccess,
}: EncounterFormModalProps) => {
  const { height: screenHeight } = useScreen()
  const modalHeight = useMemo(() => Math.min(screenHeight * 0.85, 800), [screenHeight])
  if (!openEncounter || !patientId) return null

  return (
    <DefaultModal
      overlayHeader
      size="4xl"
      contentProps={{ p: 0, height: `${modalHeight}px` }}
      bodyProps={{ maxHeight: `${modalHeight}px`, overflow: 'hidden' }}
      isOpen={!!openEncounter}
      onClose={onClose}
      render={({ onClose: onModalClose }) => (
        <EncounterForm
          patientId={patientId}
          openEncounter={openEncounter}
          assessmentId={assessmentId}
          onClose={onModalClose}
          onSuccess={onSuccess}
        />
      )}
    />
  )
}
